// Simplified Neo-Brutalism Theme - ONE primary accent color for calm, professional look

export const lightTheme = {
  // LIGHT MODE - Calm and Professional
  // Primary color: Black for text and borders
  primary: "#000000",
  secondary: "#333333",

  // ONE ACCENT COLOR - Soft Blue (lighter and calmer)
  accent: "#4D9FFF",

  // Backgrounds - Clean and simple
  background: "#FFFFFF", // Pure white
  surface: "#F8F8F8", // Very subtle gray
  surfaceAlt: "#F0F0F0", // Slightly darker gray

  // Text - High contrast
  text: "#000000", // Pure black
  textSecondary: "#333333", // Dark gray
  textLight: "#666666", // Medium gray

  // Borders and Shadows - Always black
  border: "#000000",
  shadow: "8px 8px 0 #000000",
  shadowLarge: "12px 12px 0 #000000",
  shadowSmall: "4px 4px 0 #000000",

  // Navigation
  navBackground: "#FFFFFF",
  navBorder: "#000000",
};

export const darkTheme = {
  // DARK MODE - High contrast
  // Primary color: White for text and borders
  primary: "#FFFFFF",
  secondary: "#CCCCCC",

  // ONE ACCENT COLOR - Electric Green (bright on dark)
  accent: "#00FF94",

  // Backgrounds - Dark and clean
  background: "#000000", // Pure black
  surface: "#1A1A1A", // Very dark gray
  surfaceAlt: "#2A2A2A", // Slightly lighter gray

  // Text - High contrast
  text: "#FFFFFF", // Pure white
  textSecondary: "#E5E5E5", // Light gray
  textLight: "#AAAAAA", // Medium gray

  // Borders and Shadows - Always white or accent
  border: "#FFFFFF",
  shadow: "8px 8px 0 #00FF94",
  shadowLarge: "12px 12px 0 #00FF94",
  shadowSmall: "4px 4px 0 #00FF94",

  // Navigation
  navBackground: "#000000",
  navBorder: "#FFFFFF",
};

export type Theme = typeof lightTheme;
